/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accept_ErrorInputs */

const en_accept_error = /** @type {(inputs: Accept_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error: application could not be accepted`)
};

const de_accept_error = /** @type {(inputs: Accept_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler: Bewerbung konnte nicht angenommen werden`)
};

/**
* | output |
* | --- |
* | "Error: application could not be accepted" |
*
* @param {Accept_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const accept_error = /** @type {((inputs?: Accept_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accept_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_accept_error(inputs)
	return en_accept_error(inputs)
});